import { Badge } from "@/components/ui/badge"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { MoreHorizontal } from "lucide-react"
import { useEffect, useRef, useState } from "react"

export function ContactEvaluationItems({ items, contact }: { contact: Contact, items: { [index: string]: Evaluation_Item } }) {

  const containerRef = useRef<HTMLDivElement>(null)
  const [visibleCount, setVisibleCount] = useState<number | null>(null)

  const evals = Object.entries(contact.evaluation || {})
  evals.sort((a, b) => b[1].count - a[1].count)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const observer = new ResizeObserver(() => {
      const containerWidth = container.offsetWidth
      const children = Array.from(container.querySelectorAll<HTMLElement>("[data-badge]"))
      const dropdownWidth = 28 // approximate width of the MoreHorizontal button
      const gap = 8

      let usedWidth = 0
      let count = 0
      for (const child of children) {
        const w = child.offsetWidth + gap
        if (usedWidth + w + (count < children.length - 1 ? dropdownWidth : 0) > containerWidth) break
        usedWidth += w
        count++
      }
      setVisibleCount(count)
    })

    observer.observe(container)
    return () => observer.disconnect()
  }, [evals.length])

  const hidden = visibleCount === null ? [] : evals.slice(visibleCount)

  return <div ref={containerRef} className="flex gap-2 items-center grow min-w-0 overflow-hidden flex-wrap max-h-14">
    {evals.map(([id, item]) => {
      const itemInfo = items[id]
      if (!itemInfo) return null
      const isHidden = visibleCount !== null && evals.indexOf(evals.find(e => e[0] === id)!) >= visibleCount
      return <Badge key={id} data-badge variant="outline" className={`text-nowrap shrink-0${isHidden ? " invisible absolute" : ""}`}>
        {itemInfo.name} : <span className="ml-1 font-bold text-red-500">{item.count}</span>
      </Badge>
    })}
    {hidden.length > 0 && (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <MoreHorizontal className="h-4 w-4 cursor-pointer shrink-0" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {hidden.map(([id, item]) => {
            const itemInfo = items[id]
            if (!itemInfo) return null
            return <DropdownMenuItem key={id}>{itemInfo.name} : <span className="font-bold text-red-500">{item.count}</span></DropdownMenuItem>
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    )}
  </div>
}

